import axios from "axios";
import config from "./config";
import Cookies from "js-cookie";
import router from "@/router";

function fileDownload(data, fileName) {
  let blob = new Blob([data], {
    type: "application/octet-stream"
  });
  let filename = guid()+".xls";
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var blobURL = window.URL.createObjectURL(blob);
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", filename);
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
}

/**
 *
 * @returns 生产UUID
 */
function guid() {
    var date = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") date += performance.now();
    var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return guid;
}


export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: config.baseUrl,
      headers: config.headers,
      timeout: config.timeout,
      withCredentials: config.withCredentials
    });
    // request 请求拦截器
    instance.interceptors.request.use(
      config => {
        let token = Cookies.get("token");
        // 发送请求时携带token
        if (token) {
          config.headers.token = token;
        } else {
          // 重定向到登录页面
          router.push("/login");
        }
        if (config.url.includes("ExcelFile")) {
          config.responseType = "arraybuffer";
        }
        return config;
      },
      error => {
        // 请求发生错误时
        // 判断请求超时
        if (
          error.code === "ECONNABORTED" &&
          error.message.indexOf("timeout") !== -1
        ) {
          console.log("timeout请求超时");
        }
        // 需要重定向到错误页面
        const errorInfo = error.response;
        if (errorInfo) {
          error = errorInfo.data; // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
          const errorStatus = errorInfo.status; // 404 403 500 ...
          router.push({
            path: `/error/${errorStatus}`
          });
        }
        return Promise.reject(error); // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    );

    // response 响应拦截器
    instance.interceptors.response.use(
      response => {

        if (response.config.url.includes("ExcelFile")) {
          fileDownload(response.data, "");
          return "";
        } else if(response.config.url.includes("/berry-pub/doctor/uploadImages")){
          debugger
          if(response.data && response.data.data){
            response.data.data= config.baseUrl + response.data.data
          }
          return response.data;
        } else{
          if(response.data && response.data.data && response.data.data.totalSize){
            response.data.data.totalSize=parseInt(response.data.data.totalSize)
          }
          return response.data;
        }
      },
      err => {
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = "请求错误";
              break;
            case 401:
              err.message = "未授权，请登录";
              break;
            case 403:
              err.message = "拒绝访问";
              break;
            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`;
              break;
            case 408:
              err.message = "请求超时";
              break;
            case 500:
              err.message = err.response.data
                ? err.response.data.message
                : "服务器内部错误：" + err.message;
              break;
            case 501:
              err.message = "服务未实现";
              break;
            case 502:
              err.message = "网关错误";
              break;
            case 503:
              err.message = "服务不可用";
              break;
            case 504:
              err.message = "网关超时";
              break;
            case 505:
              err.message = "HTTP版本不受支持";
              break;
            default:
          }
        }
        return Promise.reject(err); // 返回接口返回的错误信息
      }
    );
    // 请求处理
    instance(options)
      .then(res => {
        resolve(res);
        return false;
      })
      .catch(error => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/http/axios.js